/**
 *
 * Blueprint Policy Card Footer
 *
 */
import React, { FC } from 'react';

import { Box, Text, HStack } from '@chakra-ui/react';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import { EnvironmentIcon, PolicyIcon } from 'components/Icons';
import { renderEditLock } from 'containers/PolicyHub/Blueprints/Components/utils';

interface IPolicyFooter {
  data: Record<string, any>;
}

export const BlueprintCardFooter: FC<IPolicyFooter> = props => {
  const { data } = props;

  const renderTooltip = value => (
    <Box w={32} textAlign="center">
      {value}
    </Box>
  );

  return (
    <Box>
      <HStack
        w="full"
        justify="space-between"
        className="blueprint_quick_overview"
        fontSize="sm"
      >
        <CustomTooltip
          label={renderTooltip(
            'This blueprint is ' +
              (data?.created_by === 'system' ? 'not ' : '') +
              'editable',
          )}
        >
          <HStack spacing={1}>
            {renderEditLock(data.created_by)}
            <Box>Edit</Box>
          </HStack>
        </CustomTooltip>
        <CustomTooltip
          label={renderTooltip('Number of environments using this blueprint')}
        >
          <HStack spacing={1}>
            <Box as={EnvironmentIcon} boxSize={4} color="primary" />
            <Text>Environment ({data?.environments?.length ?? 0})</Text>
          </HStack>
        </CustomTooltip>
        <CustomTooltip label={renderTooltip('Total number of enabled rules')}>
          <HStack spacing={1}>
            <Box as={PolicyIcon} boxSize={3.5} color="primary" />
            <Text>Policies ({data?.rule_count})</Text>
          </HStack>
        </CustomTooltip>
      </HStack>
    </Box>
  );
};
